module.exports = __webpack_public_path__ + "static/media/reating.5eda1851.png";